import initialState from './initialState';

export default function feesReducer(state = initialState.fees, action){
  switch(action.type){
    case 'SET_CURR_FEES':
      return Object.assign({}, state, {
        curr_fees: action.curr_fees
      })

    case 'SET_OLD_FEES':
      return Object.assign({}, state, {
        old_fees: action.old_fees
      })

    case 'CANCEL_OPERATION':
      return initialState.fees

    default:
      return state;
  }
}
